// ProfileAboutSwag.js
import { connect } from 'react-redux';

import { goBack } from 'redux-first-history';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import ProfileAboutSwag from '../page/ProfileAboutSwag.jsx';

const mapStateToProps = state => {
  return {
    utm: getMeData(state, 'utm'),
    pusherConnectionState: getOperationData(
      state,
      ['pusher', 'connection'],
      'state'
    ),
    pusherSubscribedStates: getOperationData(state, ['pusher'], 'channels'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(goBack()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAboutSwag);
